import { render } from "./TransferenceComplete.vue?vue&type=template&id=793500e1&scoped=true"
import script from "./TransferenceComplete.vue?vue&type=script&lang=js"
export * from "./TransferenceComplete.vue?vue&type=script&lang=js"

import "./TransferenceComplete.vue?vue&type=style&index=0&id=793500e1&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793500e1"]])

export default __exports__